import { Sun, TreePalm, Sailboat, Waves } from "lucide-react";

// Static, colorful tropical divider echoing the logo (tree, sun, sailboat, water).
export const TropicalDivider = ({ className = "" }) => {
  return (
    <div
      className={`flex items-center justify-center gap-4 sm:gap-6 ${className}`}
      data-testid="tropical-divider"
      aria-hidden="true"
    >
      <span className="h-px w-10 sm:w-20 bg-gradient-to-r from-transparent to-[#29abe2]" />
      <TreePalm className="text-[#3f9e4d]" size={22} strokeWidth={2} />
      <Sun className="text-[#f5b301]" size={22} strokeWidth={2} />
      <Sailboat className="text-[#c1272d]" size={22} strokeWidth={2} />
      <Waves className="text-[#29abe2]" size={22} strokeWidth={2} />
      <span className="h-px w-10 sm:w-20 bg-gradient-to-l from-transparent to-[#c1272d]" />
    </div>
  );
};

export default TropicalDivider;
